/* global Clickstream */
import React, { useState, useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';

import Header from './components/layouts/Header';
import SubHeader from './components/layouts/SubHeader';
import Disclaimer from './components/layouts/Disclaimer';

import ArcGISMap from './components/features/ArcGISMap';
import Popup from './components/features/Popup';
import RefreshPageComponent from './components/features/RefreshPageComponent';
import { appConfig } from './appConfig';

const App = () => {
  const [showPopup, setShowPopup] = useState(false);
  const [popupType, setPopupType] = useState(null); // "help" | "coverage"
  const [coverageDates, setCoverageDates] = useState(null);

  useEffect(() => {
    if (!appConfig?.ArcGISMap?.coverageDateService) return;

    const fetchCoverageDates = async () => {
      try {
        const url = `${appConfig.ArcGISMap.coverageDateService}/query?where=1%3D1&outFields=*&f=pjson`;

        const response = await fetch(url);

        if (!response.ok) {
          throw new Error("Network response was not ok");
        }

        const data = await response.json();

        if (data.features && data.features.length > 0) {
          const attrs = data.features[0].attributes;

          const formatDDMMYYYY = (d) => {
            const [day, month, year] = d.split("/");
            const date = new Date(`${year}-${month}-${day}`);

            return date.toLocaleDateString("en-GB", {
              day: "2-digit",
              month: "short",
              year: "numeric"
            });
          };

          setCoverageDates({
            "2G": formatDDMMYYYY(attrs.Update_2G),
            "4G": formatDDMMYYYY(attrs.Update_4G),
            "5G": formatDDMMYYYY(attrs.Update_5G)
          });
        }
      } catch (error) {
        console.error("Failed to fetch coverage dates:", error);
      }
    };

    fetchCoverageDates();
  }, []);

  const { App: AppCfg } = appConfig;

  // Clickstream share feedback tracking
  const shareFeedback = () => {
    let pathName = window.location.pathname;

    let evar0Value = '';
    if (pathName === '/' || pathName === '') {
      evar0Value = 'home';
    } else {
      evar0Value = pathName.replace(/^\/|\/$/g, '').replace(/\//g, '-');
    }

    const endFolder = evar0Value.split('/').pop();

    const inputText = {
      eVar0: endFolder,
      eVar26: 'wirelesscoverage journey',
      eventCategory: 'wirelesscoverage_page',
      eventAction: 'click',
      eventLabel: 'share feedback',
      eventValue: '',
      section: '',
      subSection: '',
      customValue: '',
      customLabel: 'button',
    };

    if (typeof Clickstream !== 'undefined' && Clickstream.trackEvent) {
      Clickstream.trackEvent(inputText);
    }
  };
  const handleFeedbackClick = (event) => {
    event.preventDefault();

    shareFeedback();
    window.location.href = `${window.location.href}share-your-feedback/index.html`;
  };
  const openCoveragePopup = () => {
    setPopupType("coverage");
    setShowPopup(true);
  };

  const openHelpPopup = () => {
    setPopupType("help");
    setShowPopup(true);
  };

  const closePopup = () => {
    setShowPopup(false);
    setPopupType(null);
  };


  return (
    <div className="App">
      <div>
        <Header />
        <SubHeader />
      </div>

      <ArcGISMap onShowCoveragePopup={openCoveragePopup} />
      <RefreshPageComponent />
      <Disclaimer />
      <Popup
        show={showPopup}
        handleClose={closePopup}
        popUpHeading={
          popupType === "coverage"
            ? "Coverage Update"
            : AppCfg.infoPopup.heading
        }
        popupType={popupType}
      >

        {popupType === "coverage" && (
          <div>
            <strong>Coverage last updated:</strong>

            {coverageDates ? (
              <ul className="mt-2 mb-0 ps-3">
                {Object.entries(coverageDates).map(([tech, date]) => (
                  <li key={tech}>
                    <strong>{tech}:</strong>{" "}
                    <span style={{ color: "#6e4040" }}>{date}</span>
                  </li>
                ))}
              </ul>
            ) : (
              <p>Loading coverage dates...</p>
            )}
          </div>
        )}

        {popupType === "help" && (
          <>
            <b>{AppCfg.infoPopup.title}</b>
            <p>{AppCfg.infoPopup.description}</p>

            <b>What the Map Shows</b>
            <p>{AppCfg.infoPopup.whatMapShows}</p>

            <ul>
              How to Use the Map:
              {AppCfg.infoPopup.howToUse.map((item, i) => (
                <li key={i}>{item}</li>
              ))}
            </ul>

            <ul>
              Understanding the Map Colors:
              {AppCfg.infoPopup.colorInfo.map((item, i) => (
                <li key={i}>{item}</li>
              ))}
            </ul>

            <p>{AppCfg.infoPopup.footerText}</p>
            <p>{AppCfg.infoPopup.closingText}</p>
          </>
        )}
      </Popup>

      <button
        id="info"
        title="Help"
        onClick={openHelpPopup}
        className="esri-widget esri-widget--button iicon"
      >
        {/* <img
          src={AppCfg.icons.info}
          alt="Info"
        /> */}
        <span className="esri-icon-question" />
      </button>

      <button
        id="fback"
        className="btn border-0 bg-white fback"
        onClick={handleFeedbackClick}
      >
        <img
          src={AppCfg.icons.feedback}
          alt="Feedback"
        />
      </button>
    </div>
  );
};

export default App;
